// extracted by mini-css-extract-plugin
export default {"base":"Footer_base__WmHU5","main":"Footer_main__6S4ub","logo":"Footer_logo__w79hm","copyright":"Footer_copyright__2WB24"};